import utils from '@/mixins/utils.js'

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': 'dt_nascimento',
  Mãe: 'no_mae',
  MA: 'micro_area',
  Atendido: {
    field: 'dt_ultima_consulta_odonto',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
}

export const chartOptions = {
  chart: {
    height: 300,
    type: 'line',
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'straight',
    width: 2,
  },
  title: {
    text: 'CONSULTAS ODONTOLÓGICAS REALIZADAS EM GESTANTES',
    align: 'center',
  },
  grid: {
    row: {
      colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
      opacity: 0.5,
    },
  },
  xaxis: {
    categories: [],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'center',
  },
  markers: {
    size: 5,
  },
  annotations: {
    yaxis: [
      {
        y: 60,
        y2: 100,
        borderColor: '',
        fillColor: '#9dc8e1',
        label: {
          text: '',
        },
      },
      {
        y: 0,
        y2: 59,
        borderColor: '',
        fillColor: '#ffcccc',
        label: {
          text: '',
        },
      },
    ],
  },
  colors: ['#008FFB', '#ff9933', '#28a745'],
}
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
export const municipioBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  xaxis: {
    categories: [
      'Denominador estimado',
      'Cadastros e estimativa (%)',
      'Denominador informado',
      'Numerador',
      'Denominador Utilizado',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },
  colors: [
    '#159794',
    '#008000',
    '#8fce02',
    '#ffaa19',
    '#a280e2',
    '#ff0000',
    '#00a4de',
    '#e3e2e2',
  ],
}

export const municipioCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
              const valor = (val / 10).toFixed(2)
              return valor
            } */
        },
      },
    },
  },
  /*  stroke: {
        lineCap: 'round'
      }, */
  /*   colors: ['#9725b0'] */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 60) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}

export const equipeBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  /* xaxis: {
      categories: [
        '',
        '',
        '',
        '',
        ''
      ]
    }, */
  xaxis: {
    categories: [
      'Denominador informado',
      'Numerador',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#8fce02', '#ffaa19', '#ff0000', '#00a4de', '#e3e2e2'],
}

export const equipeCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
              const valor = (val / 10).toFixed(2)
              return valor
            } */
        },
      },
    },
  },
  /*  stroke: {
        lineCap: 'round'
      }, */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 60) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}
export const acsBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  /* xaxis: {
      categories: [
        '',
        '',
        '',
        '',
        ''
      ]
    }, */
  xaxis: {
    categories: [
      'Denominador informado',
      'Numerador',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#8fce02', '#ffaa19', '#ff0000', '#00a4de', '#e3e2e2'],
}

export const acsCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
              const valor = (val / 10).toFixed(2)
              return valor
            } */
        },
      },
    },
  },
  /*  stroke: {
        lineCap: 'round'
      }, */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 60) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}

export const infoHtml = `<div id='write'  class=''><h4 id='consultas-odontológicas-na-gestante'><span>CONSULTAS ODONTOLÓGICAS NA GESTANTE</span></h4><hr /><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Para todos os indicadores, recomenda-se manter o cadastro do cidadão sempre atualizado em </span><strong><span>CDS &gt;&gt; Cadastro Individual</span></strong><span>, informando preferencialmente o CPF, data de nascimento, nome completo, nome da mãe, sexo e vínculo do cidadão ou cidadã com a equipe corretos. </span></p><p><span>Se o cadastro for atualizado em </span><strong><span>PEC &gt;&gt; Cidadão</span></strong><span>, então não esquecer de vincular a equipe responsável e salvar.</span></p><p><span>Quem utilizar </span><strong><span>sistema próprio ou particular</span></strong><span>, deve também manter o cadastro do cidadão ou cidadã atualizado de acordo com as orientações que recebe da equipe de apoio.</span></p></blockquote><p>&nbsp;</p><p><strong><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_15.pdf' target="_blank"><span>Indicador 3, Pré-Natal Odontológico (PNO)</span></a></strong><span>, versa sobre a Proporção de gestantes com atendimento odontológico realizado, que analisa o Atendimento odontológico individual realizado por cirurgião dentista e tem por </span><strong><span>objetivo</span></strong><span> verificar se a gestante que é assistida no pré-natal tem realizado atendimento odontológico na perspectiva do cuidado integral e compartilhado de assistência a esse público, sendo um importante requisito para a qualidade do pré-natal realizado na Atenção Primária à Saúde (APS). </span></p><p><span>No indicador 3, gestantes com atendimento ou consulta odontológica, o </span><strong><span>parâmetro</span></strong><span> é </span><strong><span>100%</span></strong><span> de gestantes com atendimento realizado, o valor da </span><strong><span>meta</span></strong><span> é </span><strong><span>60%</span></strong><span> e o </span><strong><span>peso</span></strong><span> é </span><strong><span>2</span></strong><span>.</span></p><p>&nbsp;</p><p><strong><span>Registro</span></strong></p><p><span>O registro dos dados para o indicador 3, atendimento odontológico na gestante, é exclusivamente realizado por cirurgião dentista (CBO 2232xx) profissional devidamente lotado em alguma UBS do município. </span></p><p><span>Quando o dentista identifica que a gestante ainda não fez a primeira consulta de pré-natal com médico ou enfermeiro, ele deve solicitar que a equipe de enfermagem ou medicina inicie o acompanhamento de imediato. </span></p><p><span>Para </span><strong><span>registrar</span></strong><span> um </span><strong><span>atendimento odontológico na gestante pelo </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/guia_qualificacao_pec.pdf' target="_blank"><span>SOAP do e-SUS PEC</span></a></strong><span>, o dentista vai acessar </span><strong><span>PEC &gt;&gt; Lista de Atendimentos &gt;&gt; Atender &gt;&gt; SOAP</span></strong><span>. É importante preencher cada campo disponível, assim como faz para outros atendimentos.  </span><strong><span>Não precisa informar CID10 ou CIAP com a condição de gestação, pode informar a codificação de outros problemas que levaram a gestante ao atendimento.</span></strong></p><p><span>Os dentistas que usam e-SUS PEC, antes de realizar o registro do Atendimento Odontológico, deve verificar se a condição de gestação está ativa na lista de problemas da Folha de rosto do prontuário eletrônico, caso a usuária não esteja ativa como gestante, o profissional odontólogo deverá encaminhá-la para atendimento médico ou enfermagem para iniciar o pré-natal. </span></p><p><span>Outra forma de o dentista registrar o atendimento odontológico na gestante é pelo </span><strong><span>PEC &gt;&gt; </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/guia_qualificacao_cds.pdf' target="_blank"><span>CDS</span></a><span> &gt;&gt; Ficha de atendimento individual odontológico</span></strong><span>, preenchendo-se o cabeçalho da ficha, colocando-se as informações da gestante: CPF ou CNS, data de nascimento, sexo e marcando-se a opção Gestante.</span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>O registro realizado em </span><strong><span>sistema de prontuário eletrônico particular</span></strong><span>, ou seja, quando o município não usa o e-SUS PEC e sim outro sistema, leva em consideração o registro e exportação de dados na Ficha de Atendimento Individual Odontológico (FAIO). Nesse sentido, é ideal pedir apoio a gestão municipal e a administração do sistema particular em utilização.</span></p></blockquote><p>&nbsp;</p><h4 id='funcionalidades'><span>FUNCIONALIDADES</span></h4><hr /><p><span>Nesta tela (</span><strong><span>Consultas Odontológicas &gt;&gt; Lista</span></strong><span>) você pode filtrar por </span><strong><span>Equipe</span></strong><span>, </span><strong><span>Profissional</span></strong><span> ACS ou </span><strong><span>Microárea</span></strong><span> que a gestante está vinculada. </span></p><p><span>A visualização pode ser da </span><strong><code>Lista</code></strong><span> com os nomes das gestantes de acordo com o filtro selecionado, ou o </span><strong><code>Resultado</code></strong><span> com dados consolidados e o </span><strong><code>Gráfico</code></strong><span> com a série histórica dos resultados do indicador para o quadrimestre atual.</span></p><p>&nbsp;</p><p><strong><span>Filtro por equipe e profissional ACS ou Microárea</span></strong></p><p><span>Os filtros de nível de visualização, quando estão disponíveis permite que você selecione uma equipe (</span><strong><code>Equipes</code></strong><span>) para visualizar os dados e depois possa escolher um </span><strong><code>Profissional</code></strong><span>, geralmente um Agente Comunitário de Saúde (ACS), ou possa escolher uma </span><strong><code>Microárea</code></strong><span>. </span></p><p><span>O menor nível a ser visualizado é o </span><strong><span>Profissional</span></strong><span> (gestantes vinculadas, geralmente ao CPF do ACS) ou a </span><strong><span>Microárea</span></strong><span> (valor utilizado para delimitar a menor porção territorial dentro da equipe).</span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Se você não está visualizando a possibilidade de escolher uma </span><strong><span>Equipe</span></strong><span>, então é porque o sistema já selecionou automaticamente a equipe que você tem vínculo.</span></p><p><span>Se você não está visualizando a possibilidade de escolher um </span><strong><span>Profissional</span></strong><span> ou </span><strong><span>Micro área</span></strong><span>, então é porque você está ativo com a lotação de Agente Comunitário de Saúde e o sistema automaticamente já selecionou os dados dos cidadãos que estão vinculados ao seu CPF no cabeçalho da Ficha de Cadastro Individual (FCI) ou sua Micro área.</span></p></blockquote><p><span> </span></p><p><span>Para acessar as demais funcionalidades, você pode clicar em </span><strong><code>Lista</code></strong><span>, </span><strong><code>Resultado</code></strong><span> ou </span><strong><code>Gráfico</code></strong><span>. Isso permite um acesso fácil e visualização rápida.</span></p><p>&nbsp;</p><p><strong><span>Lista</span></strong></p><hr /><p><span>A lista (</span><strong><span>Consultas Odontológicas &gt;&gt; Lista</span></strong><span>) apresenta a relação nominal das gestantes cadastradas de acordo com o nível de visualização escolhido por você. </span><strong><span>Por exemplo:</span></strong><span> quando se seleciona a equipe e um profissional, então os dados em tela são das gestantes cadastradas com o INE da equipe selecionada e com o CPF do profissional escolhido ou micro área.</span></p><p>&nbsp;</p><p><strong><span>Filtro gestantes com ou sem atendimento odontológico</span></strong></p><p><span>Quando você marcar o botão </span><strong><code>Sem atendimento</code></strong><span>, então estará visualizando as gestantes que ainda não tem atendimento odontológico realizado na APS. Se você marcar o botão </span><strong><code>Com atendimento</code></strong><span>, vai ser mostrado em tela as gestantes que estão com atendimento odontológico realizado.</span></p><p>&nbsp;</p><p><strong><span>Baixar ou fazer o download da lista</span></strong></p><p><span>Se você desejar, pode baixar a lista nominal das gestantes em formato </span><strong><span>PDF</span></strong><span> ou </span><strong><span>XLS</span></strong><span>. Para isso, basta clicar no botão </span><strong><code>EXPORTAR</code></strong><span>.</span></p><p>&nbsp;</p><p><strong><span>Pesquisar pelo nome da gestante</span></strong></p><p><span>Para pesquisar uma gestante, você pode digitar em </span><strong><code>Nome da gestante</code></strong><span> e será mostrado somente as gestantes que contém o termo digitado na caixa de pesquisa.</span></p><p>&nbsp;</p><p><strong><span>Tabela de dados</span></strong></p><p><span>A tabela de dados permite ordenação em formato crescente e decrescente por coluna e apresenta as seguintes informações:</span></p><ul><li><p><strong><span>Nome</span></strong><span> – nome da gestante. No e-SUS, deve ser preenchido com as informações igual está no CPF;</span></p></li><li><p><strong><span>Nascimento</span></strong><span> – data de nascimento da gestante. Data de nascimento do cadastro diferente da que está na receita federal invalida o cadastro com a inconsistência de data de nascimento divergente;</span></p></li><li><p><strong><span>Mãe</span></strong><span> – nome da mãe da gestante informado no cadastro;</span></p></li><li><p><strong><span>MA</span></strong><span> – Número da micro área informado no cadastro da gestante;</span></p></li><li><p><strong><span>Atendido</span></strong><span> – data do último odontológico que a gestante recebeu;</span></p></li><li><p><strong><span>CNS</span></strong><span> - número do Cartão Nacional de Saúde da gestante;</span></p></li><li><p><strong><span>CPF</span></strong><span> - número do CPF da gestante.</span></p></li></ul><p>&nbsp;</p><p><strong><span>Fonte dos dados</span></strong></p><p><span>A </span><strong><span>Fonte</span></strong><span> mostra a origem dos dados e em qual data eles foram processados. A data na </span><strong><span>fonte</span></strong><span> dos dados aqui precisa estar o mais próximo do hoje possível. Se você tem atendimentos de pré-natal realizados depois da data que o sistema está mostrando aqui, então acionar o suporte para avaliarmos porque a sincronização não está acontecendo.</span></p><p><span>Para visualizar a quantidade de gestantes de acordo com o filtro escolhido, pode-se olhar para a informação do lado inferior direito da tabela os dois primeiros números referem-se a página atual e o terceiro número indica o total de gestantes. As setas indicando direita e esquerda servem para navegar entre as gestantes da tabela de dados que mostra 10 gestantes de cada vez.</span></p><p>&nbsp;</p><p><strong><span>Resultado</span></strong></p><hr /><p><span>O resultado  (</span><strong><span>Consultas Odontológicas &gt;&gt; Resultado</span></strong><span>) refere-se ao cálculo do indicador com relação às gestantes do denominador que estão vinculadas ao município, equipe selecionada ou ACS (considera todas as gestantes com cadastros em que na última ficha FCI, o cabeçalho está assinado com o CPF e dados de lotação do profissional ACS).</span></p><p>&nbsp;</p><p><strong><span>Tabela de dados</span></strong></p><p><span>A </span><strong><code>Tabela</code></strong><span> de dados do resultado (</span><strong><span>Consultas Odontológicas &gt;&gt; Resultado &gt;&gt; Tabela</span></strong><span>)  apresenta as colunas:</span></p><ul><li><p><strong><span>Por</span></strong><span> – </span><em><span>município</span></em><span> (quantidade de gestantes no município), </span><em><span>equipe</span></em><span> (quantidade de gestantes vinculadas ao INE da equipe selecionada) e </span><em><span>ACS</span></em><span> (quantidade de gestantes com o CPF do ACS selecionado enquanto profissional cadastrante da última FCI cadastrada no e-SUS APS);</span></p></li><li><p><strong><span>Numerador</span></strong><span> é número de gestantes com atendimento odontológico realizado na APS;</span></p><p><strong><span>Denominador</span></strong><span> é a quantidade de gestantes cadastradas na APS em que a DPP + 14 dias ocorre no quadrimestre atual (Denominador identificado);</span></p></li><li><p><strong><span>Resultado</span></strong><span> - Numerador dividido pelo Denominador multiplicado por 100. </span></p></li></ul><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>A gestante pariu no quadrimestre atual, mas sua DPP + 14 dias vai cair no quadrimestre seguinte, então ela vai ser contada no próximo quadrimestre;</span></p><p><span>Gestantes em que observada a DPP + 14 dias, a data vai cair após o dia 17 de abril, 17 de agosto ou 17 de dezembro do corrente ano, serão computadas no indicador no quadrimestre posterior ao atual.</span></p></blockquote><p>&nbsp;</p><p><strong><span>Fonte dos dados</span></strong></p><p><span>A </span><strong><span>Fonte</span></strong><span> mostra a origem dos dados e a data da última sincronização aqui com o sistema de Monitoramento e Avaliação na APS.</span></p><p><span> </span></p><p><strong><span>Gráfico</span></strong></p><p><span>O </span><strong><code>Gráfico</code><span> do Resultado</span></strong><span>  (</span><strong><span>Consultas Odontológicas &gt;&gt; Resultado &gt;&gt; Gráfico</span></strong><span>)  trata das seguintes informações legendadas: Denominador estimado, Cadastros e estimativa em porcentagem, Denominador informado, Numerador, Denominador utilizado, Faltam, Meta quadrimestral em porcentagem e Meta semanal.</span></p><p><span>Clicando nas setas para a direita e para a esquerda é possível navegar entre os níveis: Município, Equipe e ACS de acordo com o filtro selecionado.</span></p><p>&nbsp;</p><p><strong><span>Cálculo do resultado</span></strong></p><p><span>O resultado do indicador é calculado pela fórmula:</span></p><ul><li><p><strong><span>Resultado = Numerador / Denominador * 100.</span></strong></p></li></ul><p><span>É calculada uma estimativa para todos os municípios  e utilizada quando o resultado real do cadastro (Denominador identificado) for abaixo de 85% do denominador estimado. </span></p><p><span>Espera-se que o denominador identificado seja &gt;= (maior ou igual a) 85% do denominador estimado para não usar a estimativa como denominador (Denominador estimado / denominador identificado * 100 &gt;= 85%). </span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Sempre que for utilizado no indicador a estimativa como denominador, o resultado do indicador será abaixo da realidade que o município tem. Por isso é importante cadastrar todas as pessoas que estão no território para não ser utilizada a estimativa do indicador na conta do resultado.  </span></p></blockquote><p>&nbsp;</p><p><span>Para saber em qual quadrimestre a gestante vai ser computada no denominador do indicador 3, consultas de pré-natal odontológico, soma-se 14 dias a DPP e observa se o resultado está entre: janeiro a abril (primeiro quadrimestre Q1), maio a agosto (segundo quadrimestre Q2) ou setembro a dezembro (terceiro quadrimestre Q3). </span></p><p><span>Para interpretar o resultado do gráfico de barras horizontais (pelo nível de visualização), considera-se:</span></p><ul><li><p><strong><span>Denominador estimado</span></strong><span> - conforme a </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_15.pdf' target="_blank"><strong><span>Nota Técnica do indicador</span></strong></a><span>, é a estimativa calculada como controle para uma quantidade mínima de gestantes a serem consideradas no Denominador do Indicador. A conta das estimativa é assim: </span><strong><span>Cadastro municipal das gestantes, dividido pela População IBGE e multiplicado pela menor quantidade de nascidos vivos por quadrimestre do período analisado (SINASC de 2017 a 2019).</span></strong></p></li><li><p><strong><span>Cadastros e estimativa (%)</span></strong><span> - porcentagem com relação a conta (Denominador Informado, dividido por Denominador Estimado e multiplicado por 100) que define se será utilizado o Denominador Estimado ou o Denominador Informado no resultado do indicador;</span></p></li><li><p><strong><span>Denominador informado</span></strong><span> - quantidade de gestantes cadastradas na APS em que a DPP + 14 dias ocorre no quadrimestre atual (Denominador identificado);</span></p></li><li><p><strong><span>Numerador</span></strong><span> - a quantidade de gestantes com atendimento odontológico realizado na APS;</span></p></li><li><p><strong><span>Denominador utilizado</span></strong><span> - SE Cadastros e estimativa &gt;= 85, ENTÃO é o valor do Denominador Informado, CASO CONTRÁRIO, é o valor do Denominador Estimado;</span></p></li><li><p><strong><span>Faltam</span></strong><span> - quantidade de gestantes que faltam para chegar aos 100% de acompanhamento (Numerador) no indicador de consultas pré-natal odontológico; </span></p></li><li><p><strong><span>Meta quadrimestral (%)</span></strong><span> - para o indicador 3, consultas pré-natal odontológico, a meta é 60%.</span></p></li><li><p><strong><span>Meta semanal</span></strong><span> - quantidade de gestantes que precisam de atenção para que constem no numerador do indicador.</span></p></li></ul><p><span>O </span><strong><span>gráfico de rosca</span></strong><span> representa o resultado percentual do indicador em relação ao total de gestantes cadastradas e consideradas no quadrimestre atual de acordo com o nível selecionado.</span></p><p><span>O </span><strong><span>emoticon ou emoji</span></strong><span> analisa a diferença de resultado entre o mês atual e o mês anterior e fica:</span></p><ul><li><p><strong><span>Feliz</span></strong><span> - quando a diferença é positiva (verde);</span></p></li><li><p><strong><span>Chateado</span></strong><span> - quando a diferença é zero (laranja);</span></p></li><li><p><strong><span>Triste</span></strong><span> - quando a diferença é negativa (vermelho).</span></p></li></ul><p>&nbsp;</p><p><strong><span>Gráfico</span></strong></p><hr /><p><span>O gráfico (</span><strong><span>Consultas Odontológicas  &gt;&gt; Gráfico</span></strong><span>) mostra a série histórica ao longo do tempo para a visualização sobre se os resultados do indicador: melhoraram (linha crescente), pioraram (linha caindo) ou se mantiveram estáveis (linha reta).</span></p><p><span>As cores representam a que nível pertence a informação (Município, Equipe ou ACS).</span></p><p><span>Ao passar o mouse ou fazer gesto sobre o gráfico, aparece as informações de quantidade e nível de acordo com o mês que fica abaixo do gráfico.</span></p><p><span>Caso você deseje fazer o download ou baixar (SVG, PNG ou CSV) os dados do gráfico, basta clicar nos três pontinhos do lado direito superior dele. </span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Geralmente a série histórica a nível de micro área pode estar quebrada, ou seja, como se estivesse faltando dados. Isso acontece, porque nos indicadores de pré-natal é comum o denominador ser 0 (zero), ou seja, não tem gestante no denominador do quadrimestre atual.</span></p></blockquote><p>&nbsp;</p><p><strong><span>Fonte dos dados</span></strong></p><p><span>A </span><strong><span>Fonte</span></strong><span> mostra a origem dos dados e a data da última sincronização aqui com o sistema de Monitoramento e Avaliação na APS.</span></p><p>&nbsp;</p></div>`
